import req from "../http";

const approveInterview = {
  // 取得 面談紀錄歷程(登入者)
  getInterviewRecordForUser(matchId) {
    return req("get", `/Recruitment/ApproveInterview/interviewer/${matchId}`);
  },

  // 取得 面談紀錄歷程(HR)
  getInterviewRecordForHr(matchId) {
    return req("get", `/Recruitment/ApproveInterview/${matchId}`);
  },

  // 依據InterviewId 取得 面談紀錄歷程(HR)
  getInterviewRecordByInterviewId(interviewId) {
    return req("get", `/Recruitment/ApproveInterview/ByInterviewId/${interviewId}`);
  },

  // 取得 面談紀錄歷程(部門主管)
  getInterviewRecordForSupervisor(matchId) {
    return req("get", `/Recruitment/ApproveInterview/dept/${matchId}`);
  },

  // 核定面談結果
  putApproveInterview(params) {
    return req("put", "/Recruitment/ApproveInterview", params);
  },
};

export default approveInterview;